<template>
    <span :class="classObj">
        <input
            v-model="checked"
            @focus="addFocusClass()"
            @blur="removeFocusClass()"
            @click="removeFocusClass()"
            :id="$props.id"
            :aria-checked="value"
            class="shared-switch__input"
            type="checkbox"
            role="switch"
            :name="name"
        />
    </span>
</template>

<script>
export default {
    data() {
        return {
            focusRecieved: false,
        };
    },
    props: {
        // v-model on shared-switch
        value: {
            type: Boolean,
            required: true,
        },
        id: String,
        name: String,
    },
    methods: {
        addFocusClass() {
            this.focusRecieved = true;
        },
        removeFocusClass() {
            this.focusRecieved = false;
        },
    },
    computed: {
        checked: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        classObj() {
            return {
                'shared-switch': true,
                'shared-switch_checked': this.checked,
                'shared-switch_focus-unchecked': this.focusRecieved && !this.checked,
                'shared-switch_focus-checked': this.focusRecieved && this.checked,
            };
        },
    },
};
</script>
